import PropTypes from 'prop-types';

const UserType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  email: PropTypes.string,
  acl: PropTypes.number,
  admissions_permitted: PropTypes.bool,
  enrollment_permitted: PropTypes.bool,
  billing_permitted: PropTypes.bool,
  medical_permitted: PropTypes.bool,
  secure_permitted: PropTypes.bool,
  scheduling_permitted: PropTypes.bool,
  financial_permitted: PropTypes.bool,
  communications_permitted: PropTypes.bool,
  counselor_permitted: PropTypes.bool,
  reader_permitted: PropTypes.bool,
  manage_review_permitted: PropTypes.bool,
  is_admin: PropTypes.bool,
  is_super_admin: PropTypes.bool
});

export default UserType;
